import React from 'react';
import { Icon } from 'react-fa';

const ProductComponent = ({ icon, title, summary }) => {
	return (
  			<div className="col-xs-12 col-md-4 col-centered">
	          	<div className="component-container">
		          	<span className="component-circle">
		          		<Icon className="componentIcon" name={icon} size="2x" />
		          	</span>
		          	<br />
		          	<h4 className="component-title">{title}</h4>
		          	<h6 className="component-summary">{summary}</h6>
	          	</div>
	          </div>
	);
};

export { ProductComponent };



/** WEBPACK FOOTER **
 ** ./src/common/ProductComponent.js
 **/